<template>
    <section  v-if="hasPermissions(['Assignment-Status Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Use the Date, Supervisor, and Shift filters below to view the corresponding complete or incomplete rooms for each assignment.
            </p>
        </div>

        <div class="row bar__container" style="margin-bottom: 20px;">
            <div class="col-md-12 py-0 mb-3 mt-4">
                <div class="input-field my-0">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            
        </div>

        <div class="row mb-3 no-gutters">
            <FormDynamic 
                :form_format="form_format"
                :form_data="form_data"
                :array_options="array_options"
                :content_align_x="'no-justify'"
                class="mb-4"
            />
            <div class="col-12">
                <div class="tab-content" v-show="daily_assignments.length">
                    <div class="tab-pane fade active show" >
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="v-card v-sheet theme--light">
                                    <DinamicTable
                                        :headers="table_headers"
                                        :items="daily_assignments"
                                        :search="search"
                                        :checkable="false"
                                        :updateable="false"
                                        :link="'/assignment-daily-assignments/'"
                                        :historiable="false"
                                        @emitAction="getRooms($event)"
                                        :link_action_href="'assignment-daily-assignment-complete/'"
                                        :totals="totals"
                                    />
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <InfoRooms
            :rest_api="rest_api"
            :breadcrumb="breadcrumb"
            :form_data="form_data"
            ref="info_rooms"
        />


        <WaitingModal/>
    </section>

    <section v-else class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import FormDynamic          from    '@/components/FormDynamic.vue'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './resources'
import FormResources        from    './form_resources'
import DinamicTable         from    '@/components/DinamicTable'
import InfoRooms            from './InfoRooms'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }        from    'notyf'
import 'notyf/notyf.min.css'; 
import moment from 'moment'
import { changeDateForAssignmentStatus, getSocket } from '../../../plugins/socket'
import eventBus from '../../../plugins/eventBus'

const notyf = new Notyf({
    duration: 8000,
})

export default {

    name: 'Statuses',

    components: {
        Breadcrumb,
        WaitingModal,
        DinamicTable,
        FormDynamic,
        InfoRooms
    },

    data()
    {
        return {
            notyf,
            user:               this.get_user(),
            title_page:         'Assignment status',
            title_modal_show:   '',
            rest_api:           `daily_assignment_status`,
            form_format:        FormResources.form_format,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            form_data:{
                current_date:  this.currentDateToString(),
                supervisor_id: null,
                shift_id: ''
            },
            min_current_date:   this.dateDecrement(30).original_format_date,
            max_current_date:   this.currentDateToString(),
            single_select:      false,
            table_selection:    [],
            search:             '',
            daily_assignments:  [],
            array_options:      {
                supervisor_id: [],
                shift_id: FormResources.shifts
            },
            totals:             [],
            subscribedChannels: [],
            first_time: true,
            moment,
        }
    },

    watch: {

        form_data:
        {
            handler(val)
            {
                if(!this.first_time)
                {
                    let url = `${this.rest_api}?`
                    this.subscribeToAssignmentStatusChannel(val.current_date)
                    if(val.current_date != this.currentDateToString())
                    {
                        url += `date=${val.current_date}&`
                    }
                    if(val.supervisor_id)
                    {
                        url += `supervisor_id=${val.supervisor_id}&`
                    }
                    if(val.shift_id)
                    {
                        url += `shift_id=${val.shift_id}&`
                    }
                    
                    this.fetchInitialData(url)
                }
                else
                {
                    this.first_time = false
                }
                
            },
            deep: true
        },

    },

    methods: 
    {
        getRooms({index, header})
        {
            window.$('#static-info-rooms').modal('show')

            const daily_assignment = this.daily_assignments[index]
            this.$refs.info_rooms.initialSetup(daily_assignment, header)
        },

        fill_data(data)
        {

            if(this.currentDateToString() == this.form_data.current_date)
            {
                this.array_options = 
                {
                    supervisor_id: data.supervisors || [],
                    shift_id: FormResources.shifts
                }
            }

            if(this.first_time)
            {
                if(data.supervisor_id)
                {
                    this.form_data.supervisor_id = data.supervisor_id
                }
                else
                {

                    this.form_data.supervisor_id = ''
                }
            }


            this.daily_assignments = data.daily_assignments

            this.replaceTotals(data.totals, data.averages, true )
        },

        replaceDailyAssignment(data)
        {
            let found_index = this.daily_assignments.findIndex(item => item.id == data.daily_assignment.id)

            let old_daily_assignment = {...this.daily_assignments[found_index]}

            if(found_index > -1)
            {
                this.daily_assignments.splice(found_index, 1, data.daily_assignment)

                this.replaceTotals(data.totals, data.averages, false, old_daily_assignment, data.daily_assignment)
            }
        },

        replaceTotals(totals, averages, first_time, old_daily_assignment, new_daily_assignment)
        {
            if(first_time)
            {
                this.totals = []
                const new_totals = {
                    description:                {value: 'TOTAL', type: 'title', text: '', show: true},
                    total_rooms_today:          {value: totals.total_rooms_today, type: '', text: 'Total Rooms', show: true},
                    total_rooms_cleaned:        {value: totals.total_rooms_cleaned, type: 'text_link_action', text: 'Total Rooms Cleaned', show: true},
                    total_rooms_not_cleaned:    {value: totals.total_rooms_not_cleaned, type: 'text_link_action', text: 'Total Rooms Left to clean', show: true},
                    complete:                   {value: totals.complete, type: 'percentage_value', text: 'Total Complete', show: true},
                }

                const new_averages = {
                    description:                {value: 'AVERAGE', type: 'title', show: true},
                    total_rooms_today:          {value: averages.average_total_rooms, type: '', text: 'Total Rooms Average', show: true},
                    total_rooms_cleaned:        {value: averages.average_total_rooms_cleaned, type: '', text: 'Total Cleaned Rooms Average', show: true},
                    total_rooms_not_cleaned:    {value: averages.average_total_rooms_not_cleaned, type: '', text: 'Total Rooms Left to clean Average', show: true},
                    complete:                   {value: this.total_complete_average, type: 'percentage_value', text: 'Complete Average', show: true},
                }

                this.totals.push(new_totals)
                this.totals.push(new_averages)
            }
            else
            {
                this.totals[0].total_rooms_today.value          -= old_daily_assignment.total_rooms_today
                this.totals[0].total_rooms_cleaned.value        -= old_daily_assignment.total_rooms_cleaned
                this.totals[0].total_rooms_not_cleaned.value    -= old_daily_assignment.total_rooms_not_cleaned

                this.totals[0].total_rooms_today.value          += new_daily_assignment.total_rooms_today
                this.totals[0].total_rooms_cleaned.value        += new_daily_assignment.total_rooms_cleaned
                this.totals[0].total_rooms_not_cleaned.value    += new_daily_assignment.total_rooms_not_cleaned

                this.totals[0].complete.value = ((this.totals[0].total_rooms_cleaned.value / this.totals[0].total_rooms_today.value) * 100).toFixed(1)

                this.totals[1].total_rooms_today.value = (this.totals[0].total_rooms_today.value / this.daily_assignments.length).toFixed(1)
                this.totals[1].total_rooms_cleaned.value = (this.totals[0].total_rooms_cleaned.value / this.daily_assignments.length).toFixed(1)
                this.totals[1].total_rooms_not_cleaned.value = (this.totals[0].total_rooms_not_cleaned.value / this.daily_assignments.length).toFixed(1)

                this.totals[1].complete.value = this.total_complete_average

            }

            
        },

        async fetchInitialData(url = undefined, first_time = false)
        {
            if(first_time)
            {
                url = `${this.rest_api}?first_time=${first_time}`
            }

            await this.api_request(url)
            this.fetchAssociatesOnSchedule()
        },

        async fetchAssociatesOnSchedule()
        {
            const res = await this.post(`${this.rest_api}/schedule/associates`, {date: this.form_data.current_date})

            if(res.status)
            {
                const result = res.data.data;
                this.daily_assignments.forEach(daily_assignment => {
                    const found_assignment = result.find(item => item.daily_assignment_id === daily_assignment.id)
                    if(found_assignment)
                    {
                        if(found_assignment.associates.length)
                        {
                            daily_assignment.name_concat = found_assignment.associates.map(item => item.name).join(' - ')
                        }
                        else
                        {
                            daily_assignment.name_concat = null
                        }
                    }
                });
            }
            else
            {
                this.error_handling(res)
            }
        },

        subscribeToAssignmentStatusChannel(date)
        {   
            if(date)
            {
                date = moment(date).format('MM-DD-YY')
            }

            const date_for_channel = date || this.getTodayDate()

            changeDateForAssignmentStatus(date_for_channel)

            const channelName = `status-${this.user.facility_id}-${date_for_channel}`

            getSocket().on(channelName, (data) => {
                console.log(data);
                this.replaceDailyAssignment(data);
            })
            
        },

    },

    async mounted()
    {
        if(this.hasPermissions(['Assignment-Status Read']))
        {
            this.form_format[0]['maxlength'] = this.max_current_date

            await this.fetchInitialData(undefined, true)

            // this.fetchAssociatesOnSchedule()

            eventBus.$on('assignment_status', () => 
            {
                this.subscribeToAssignmentStatusChannel()
            })
        }
    },

    computed: {
        total_complete_average()
        {
            if(this.daily_assignments.length)
            {
                let sum = this.daily_assignments.reduce((total, assignment) => total + (parseFloat(assignment.complete) || 0), 0);

                return (sum / this.daily_assignments.length).toFixed(1)
            }

            return 0
        }

        
    }
}
</script>